import { render, staticRenderFns } from "./NetworkItem.vue?vue&type=template&id=5d42d6b8&scoped=true&"
import script from "./NetworkItem.vue?vue&type=script&lang=js&"
export * from "./NetworkItem.vue?vue&type=script&lang=js&"
import style0 from "./NetworkItem.vue?vue&type=style&index=0&id=5d42d6b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d42d6b8",
  null
  
)

export default component.exports